<template>
  <footer class="home-footer">
    <div class="home-footer__inner">
      <div class="home-footer__logo">PAXA</div>
      <p class="home-footer__company">深圳市湃萨科技有限公司</p>
      <p class="home-footer__meta">
        地址：广东省深圳市南山区科技园<br />
        邮箱：PAXA@SZPAXA.COM.CN<br />
        <a href="https://beian.miit.gov.cn" style="text-underline: none;text-decoration: none;color: white">粤ICP备2026058879号-1</a>
      </p>
      <p class="home-footer__copy">深圳市湃萨科技有限公司</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'HomeFooter'
}
</script>

<style scoped>
.home-footer {
  width: 100%;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  padding: 48px 0 40px;
}

.home-footer__inner {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  text-align: center;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.home-footer__logo {
  font-size: clamp(18px, 1.5vw, 22px);
  font-weight: 600;
  letter-spacing: 0.14em;
  margin-bottom: 14px;
}

.home-footer__company {
  margin: 0 0 18px;
  font-size: clamp(13px, 1.1vw, 15px);
  line-height: 1.5;
  opacity: 0.96;
}

.home-footer__meta {
  margin: 0 0 22px;
  font-size: clamp(11px, 0.95vw, 13px);
  line-height: 1.85;
  opacity: 0.68;
}

.home-footer__copy {
  margin: 0;
  font-size: clamp(10px, 0.85vw, 12px);
  opacity: 0.52;
}
</style>
